import PropTypes from 'prop-types';
import React, { Component } from 'react';
import IsolatedResource from './IsolatedResource';
import ActionText from '../core/ActionText';
import { withStyles } from '@material-ui/core/styles';
import { globalStyles as styles } from '../core/style/gstheme';

class ResourceListStructure extends Component {

  render() {

    const { onSelect, resources, noneFound, datasetIRI, graph, activeResource, iriOptions, useWorkflow, addToDataset,
      defaultLang, viewLang, isReadOnly} = this.props;

    return (
      <div data-test="resource-list">
        {noneFound || !resources ?
          <ActionText format="result" offset="100px">No results.</ActionText>
          :
          resources.map(resource => <IsolatedResource
            key={resource}
            id={resource}
            useWorkflow={useWorkflow}
            datasetIRI={datasetIRI}
            iriOptions={iriOptions}
            lang={defaultLang}
            viewLang={viewLang}
            addToDataset={addToDataset}
            activeResource={activeResource}
            graph={graph}
            isReadOnly={isReadOnly}
            onSelect={onSelect} />)
        }
      </div>
    );
  }

}

ResourceListStructure.propTypes = {
  datasetIRI: PropTypes.string,
  resources: PropTypes.array,
  isReadOnly: PropTypes.bool,
  useWorkflow: PropTypes.bool,
  activeResource: PropTypes.string,
  defaultLang: PropTypes.string.isRequired,
  addToDataset: PropTypes.func,
  viewLang: PropTypes.string,
  graph: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  nonFound: PropTypes.bool,
  classes: PropTypes.object,
  iriOptions: PropTypes.object
};

export default withStyles(styles)(ResourceListStructure);